import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '../views/index/index.vue'
import Preview from '../views/preview/index.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    redirect: { name: 'Index' },
  },
  {
    path: '/index',
    name: 'Index',
    component: Index,
    // meta:{
    //   auth: true
    // }
  },
  {
    path: '/preview/:id',
    name: 'Preview',
    component: Preview,
    // meta:{
    //   auth: true
    // }
  },
  {
    path: '/login',
    name: 'Login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/login/index.vue')
  },
  {
    path: '/detail',
    name: 'Detail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/detail/index.vue')
  },
  {
    path: '/qrcode',
    name: 'Qrcode',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/qrcode/index.vue')
  },{
    path: '/shortmsg',
    name: 'ShortMsg',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/shortmsg/index.vue')
  },{
    path: '/useRouter/:q/:id',
    name: 'useRouter',
    props: true,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/shortmsg/useRouter.vue')
  },
  {
    path: '/otherorder',
    name: 'OtherOrder',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/otherorder/index.vue')
  },
  {
    path: '/sign',
    name: 'Sign',
    meta:{
      keepAlive:false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/sign/index.vue')
  },
  {
    path: '/pay/pcpay',
    name: 'Pcpay',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/paypc/index.vue')
  },
  {
    path: '/order',
    name: 'OrderList',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/order/list.vue')
  },
  {
    path: '/cpsorder',
    name: 'CpsOrder',
    meta:{
      keepAlive:true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/order/cpsOrder.vue')
  },
  {
    path: '/order/detail',
    name: 'OrderDetail',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/order/detail.vue')
  },
  {
    path: '/cps/:iid',
    name: 'Cps',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/cps/index.vue')
  },{
    path: '/3D',
    name: '3D',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/3D/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
